export const SERVER_IP = 'http://localhost';
export const ENDPOINT_PORT = '3000';
export const BASE_SERVER_IP_PORT = `${SERVER_IP}:${ENDPOINT_PORT}`;
export const GET_DOWNLOAD_LINK_URL = `api/getdownloadlink`;
export const SEND_EMAIL = `api/sendemail`;



// WEBPACK FOOTER //
// ./src/constant/urlConfig.js